import Highcharts from 'highcharts';
import { filterByCategory } from "./data.js";

function getMandatyFinanse() {
    const categories = [
        'Mandaty: liczba wystawionych',
        'Etaty: liczba strażników',
        'Budżet',
        'Mandaty: wartość',
        'Mandaty: liczba wystawionych dot. PRD',
        'Mandaty: wartość wystawionych dot. PRD',
        'Pouczenia: liczba'
    ];
    const data = filterByCategory(categories);

    // Filtruj miasta z kompletnymi danymi dla podstawowych statystyk
    const validData = data.filter(sm =>
        sm['Mandaty: liczba wystawionych'] !== null &&
        sm['Etaty: liczba strażników'] !== null &&
        sm['Budżet'] !== null &&
        sm['Mandaty: wartość'] !== null &&
        typeof sm['Mandaty: liczba wystawionych'] === 'number' &&
        typeof sm['Etaty: liczba strażników'] === 'number' &&
        typeof sm['Budżet'] === 'number' &&
        typeof sm['Mandaty: wartość'] === 'number'
    );

    validData.forEach(sm => {
        // Mandaty na strażnika miesięcznie
        sm.finesPerGuardMonthly = Math.round((sm['Mandaty: liczba wystawionych'] / sm['Etaty: liczba strażników'] / 12) * 10) / 10;

        // Stopień samofinansowania (w %)
        sm.selfFinancingRate = Math.round((sm['Mandaty: wartość'] / sm['Budżet']) * 100 * 10) / 10;

        // Średnia wartość mandatu PRD
        if (sm['Mandaty: wartość wystawionych dot. PRD'] && sm['Mandaty: liczba wystawionych dot. PRD']) {
            sm.avgPrdFine = Math.round(sm['Mandaty: wartość wystawionych dot. PRD'] / sm['Mandaty: liczba wystawionych dot. PRD']);
        } else {
            sm.avgPrdFine = null;
        }
    });

    return validData.sort((a, b) => b.finesPerGuardMonthly - a.finesPerGuardMonthly);
}

export function chartMandaty(id) {
    if (!document.getElementById(id)) return;

    const data = getMandatyFinanse();

    // Chart 1: Mandaty na strażnika (combined with Average Fine Value)
    const categories1 = data.map(item => item.city);
    const finesPerGuardData = data.map(item => item.finesPerGuardMonthly);
    const avgFineData = data.map(item => item.avgPrdFine || 0);

    const sumOfMandaty = data.reduce((sum, city) => sum + city['Mandaty: wartość wystawionych dot. PRD'], 0)
    const countOfMandaty = data.reduce((sum, city) => sum + city['Mandaty: liczba wystawionych dot. PRD'], 0)

    const average = sumOfMandaty / countOfMandaty


    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Efektywność mandatowa i średnia wysokość kary' },
        xAxis: {
            categories: categories1,
            type: 'category',
            title: { text: null },
            labels: { style: { fontSize: '16px' } }
        },
        yAxis: [{
            title: {
                text: null,
            },
            labels: {
                style: { color: '#999' },
                format: '{value} zł'
            },
            opposite: true,
            plotLines: [{
                value: average,
                color: '#999', // Kolor niebieski jak słupki
                dashStyle: 'ShortDot',
                width: 3,
                zIndex: 5,
                label: {
                    text: `Średnia: ${average.toFixed(0)} zł`,
                    align: 'right',
                    verticalAlign: 'bottom',
                    style: { color: '#000', fontWeight: 'bold' }
                }
            }]
        }, {
            min: 0,
            title: {
                text: null,
            },
            labels: {
                style: { color: '#e74c3c' }
            }
        }],
        legend: {
            enabled: false
        },
        tooltip: {
            shared: true
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    formatter: function () {
                        if (this.series.name === 'Średnia wartość mandatu PRD') {
                            return this.y ? `${this.y} zł` : '';
                        } else {
                            return this.y;
                        }
                    }
                }
            },
            series: {
                grouping: false,
                borderWidth: 0
            }
        },
        credits: { enabled: false },
        series: [{
            name: 'Średnia wartość mandatu PRD', // Background series
            type: 'bar',
            yAxis: 0,
            data: avgFineData,
            color: '#999',
            linkedTo: 'main',
            pointPlacement: -0.2
        }, {
            name: 'Mandaty PRD na strażnika (miesięcznie)', // Main series
            type: 'bar',
            yAxis: 1,
            data: finesPerGuardData,
            color: '#e74c3c',
            id: 'main'
        }]
    });
}


export function chartSelfinancing(id) {
    const data = getMandatyFinanse();
    const data2 = [...data].sort((a, b) => b.selfFinancingRate - a.selfFinancingRate);
    const categories = data2.map(item => item.city);
    const selfFinancingData = data2.map(item => item.selfFinancingRate);
    const backgroundData = selfFinancingData.map(() => 100);

    const avg = selfFinancingData.reduce((a, b) => a + b, 0) / selfFinancingData.length

    const barColor = '#27ae60';
    const belowAvgColor = '#548067';

    const selfFinancingDataWithColor = data2.map(item => ({
        y: item.selfFinancingRate,
        color: item.selfFinancingRate >= avg ? barColor : belowAvgColor
    }));

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Stopień pokrycia budżetu wpływami z mandatów' },
        subtitle: { text: 'Stopień pokrycia budżetu SM wpływami z mandatów' },
        xAxis: {
            categories: categories,
            title: { text: null },
            labels: { style: { fontSize: '14px' } }
        },
        yAxis: {
            title: { text: '%' },
            min: 0,
            max: 100, // Ensure the axis goes up to at least 100%
            labels: { format: '{value}%' }
        },
        legend: { enabled: false },
        tooltip: {
            valueSuffix: '%'
        },
        plotOptions: {
            bar: {
                grouping: false,
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    format: '{y}%'
                }
            },
            series: {
                borderWidth: 0
            }
        },
        credits: { enabled: false },
        series: [{
            name: 'Budżet',
            data: backgroundData,
            color: '#ecf0f1', // Light gray background
            enableMouseTracking: false,
            dataLabels: { enabled: false }
        }, {
            name: 'Pokrycie budżetu',
            data: selfFinancingDataWithColor,
            color: '#27ae60'
        }]
    });
}

/**
 * @param {string} id
 */
export function chartPriceOfFine(id) {
    const data = getMandatyFinanse()

    data.forEach(sm => {
        sm.pricePerAction = Math.round(sm['Budżet'] /
            (sm['Mandaty: liczba wystawionych'] + (sm['Pouczenia: liczba'] || 0)))

        sm.pricePerFine = Math.round(sm['Budżet'] /
            (sm['Mandaty: liczba wystawionych']))
    })


    const data2 = [...data].sort((a, b) => b.pricePerAction - a.pricePerAction);
    const categories = data2.map(item => item.city);
    const pricePerActionData = data2.map(item => item.pricePerAction);
    const pricePerFineData = data2.map(item => item.pricePerFine);

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Budżet SM per mandat lub pouczenie' },
        subtitle: { text: 'Ile kosztuje wystawienie jednego mandatu lub pouczenia?' },
        xAxis: {
            categories: categories,
            title: { text: null },
            labels: { style: { fontSize: '14px' } }
        },
        yAxis: {
            title: { text: '' },
            labels: { format: '{value} zł' }
        },
        legend: {
            enabled: true,
            verticalAlign: 'top',
            reversed: true
        },
        tooltip: {
            valueSuffix: ' zł',
            shared: true
        },
        plotOptions: {
            bar: {
                grouping: false,
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    format: '{y} zł'
                }
            },
            series: {
                borderWidth: 0
            }
        },
        credits: { enabled: false },
        series: [{
            name: 'Budżet per mandat',
            data: pricePerFineData,
            color: '#999',
        }, {
            name: 'Budżet per mandat lub pouczenie',
            data: pricePerActionData,
            color: '#a70000',
            dataLabels: {
                inside: true
            }
        }]
    });
}